export default __webpack_public_path__ + "static/media/J6.403481e3.jpg";